var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.81,1.48C11.69,1.48,1.84,11.34,1.84,23.46s9.86,21.98,21.98,21.98,21.98-9.86,21.98-21.98S35.93,1.48,23.81,1.48Zm0,40.95c-10.46,0-18.98-8.51-18.98-18.98S13.35,4.48,23.81,4.48s18.98,8.51,18.98,18.98-8.51,18.98-18.98,18.98Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.11,32.14c-.58,0-1.07,.2-1.47,.6-.4,.4-.6,.89-.6,1.47s.2,1.07,.6,1.47c.4,.4,.89,.6,1.47,.6s1.07-.2,1.47-.6c.4-.4,.6-.89,.6-1.47s-.2-1.07-.6-1.47c-.4-.4-.89-.6-1.47-.6Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.22,10.63c-1.86,0-3.45,.45-4.78,1.34s-2.3,2.12-2.92,3.69l2.89,1.2c.51-1.02,1.16-1.79,1.97-2.32,.8-.53,1.75-.79,2.84-.79,1.16,0,2.08,.29,2.76,.87,.67,.58,1.01,1.38,1.01,2.4,0,.73-.2,1.43-.6,2.1-.4,.67-1.07,1.47-2.02,2.38-1.35,1.27-2.19,2.37-2.54,3.28s-.52,2.06-.52,3.44h3.11c0-1.13,.18-2.05,.55-2.76s1-1.52,1.91-2.43c1.2-1.2,2.04-2.27,2.51-3.19,.47-.93,.71-1.9,.71-2.92,0-1.93-.62-3.46-1.86-4.59-1.24-1.13-2.91-1.69-5.02-1.69Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon_support.801e7f6a454bab30f301debee910be41.svg";
export { ForwardRef as ReactComponent };